import React from 'react';
import type { FC } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import CloudArrowUpIcon from '@atlaskit/icon/core/cloud-arrow-up';
import { ButtonMenuItem } from '@atlaskit/side-nav-items/button-menu-item';
import Button from '@atlaskit/button/default/button';

import { useImportContentStore } from '../ImportContentStore.tsx';

const i18n = defineMessages({
	buttonText: {
		id: 'import-content.button.text',
		defaultMessage: 'Import from other tools',
		description:
			'Text on the button that opens a user experience to import content into Confluence',
	},
});

type ImportContentButtonProps = {
	isMenuButton?: boolean;
	closePopup?: (reason?: string | undefined) => void;
};

export const ImportContentButton: FC<ImportContentButtonProps> = ({
	isMenuButton = true,
	closePopup,
}) => {
	// eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
	const [, importContentActions] = useImportContentStore();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				source: 'importContentButton',
			},
		}).fire();
		importContentActions.setShouldRenderModal(true);
		importContentActions.setShowImportContentModal(true);
		closePopup?.('import content clicked');
	};

	return isMenuButton ? (
		<ButtonMenuItem
			elemBefore={<CloudArrowUpIcon label="" color="currentColor" />}
			onClick={handleClick}
			testId="import-content-menu-button-nav4"
		>
			<FormattedMessage {...i18n.buttonText} />
		</ButtonMenuItem>
	) : (
		<Button onClick={handleClick} appearance="primary" testId="import-content-button">
			<FormattedMessage {...i18n.buttonText} />
		</Button>
	);
};
